// extracted by mini-css-extract-plugin
export default {"button":"CTAButton_button__2X7a4"};